import React, { useState, useEffect } from "react";
import { Button } from "./ui/button";

const Hero = () => {
  // Countdown timer state
  const [timeLeft, setTimeLeft] = useState({
    days: 6,
    hours: 2,
    minutes: 39,
    seconds: 17
  });

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prevTime => {
        let newSeconds = prevTime.seconds - 1;
        let newMinutes = prevTime.minutes;
        let newHours = prevTime.hours;
        let newDays = prevTime.days;

        if (newSeconds < 0) {
          newSeconds = 59;
          newMinutes -= 1;
        }
        if (newMinutes < 0) {
          newMinutes = 59;
          newHours -= 1;
        }
        if (newHours < 0) {
          newHours = 23;
          newDays -= 1;
        }

        return {
          days: newDays,
          hours: newHours,
          minutes: newMinutes,
          seconds: newSeconds
        };
      });
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  const scrollToPurchase = () => {
    const element = document.getElementById('purchase-section');
    element?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="bg-gradient-to-br from-red-50 to-red-100 py-20 px-6">
      <div className="max-w-6xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Left Content */}
          <div>
            <h1 className="text-5xl md:text-6xl font-bold text-gray-900 mb-6 leading-tight">
              <span className="text-red-600">LIVRO TRANSFORMADOR -</span> A jornada completa pela vida de Jesus Cristo que mudará sua perspectiva sobre prosperidade eterna...
            </h1>
            
            <p className="text-xl text-gray-700 mb-8 leading-relaxed">
              Sim, eu sei que pode parecer apenas mais um livro. Talvez até distante da sua realidade hoje que <strong>busca crescimento espiritual e propósito de vida. Mas é transformador.</strong> Mais de milhares de leitores já foram impactados por esta narrativa, e agora eu vou mostrar para VOCÊ o caminho neste evangelho harmonizado.
            </p>

            <Button 
              onClick={scrollToPurchase}
              className="bg-red-600 hover:bg-red-700 text-white text-xl py-6 px-12 rounded-lg shadow-lg transform hover:scale-105 transition-all duration-300 mb-8"
            >
              Quero ler A Vida de Jesus
            </Button>

            <div className="bg-yellow-100 border-l-4 border-yellow-500 p-4 mb-6">
              <p className="text-yellow-800 font-medium">
                ⚠️ <strong>AVISO:</strong> Este livro levará você a uma jornada transformadora pela vida de <strong>Jesus Cristo</strong>, onde você caminhará ao lado d'Ele em cada momento.
              </p>
            </div>
          </div>

          {/* Right Content - Countdown and Book Image */}
          <div className="text-center">
            <div className="bg-white rounded-2xl shadow-2xl p-8 mb-8">
              <h3 className="text-2xl font-bold text-gray-900 mb-6">OFERTA ESPECIAL:</h3>
              
              <div className="grid grid-cols-4 gap-4 mb-6">
                <div className="text-center">
                  <div className="bg-red-600 text-white rounded-lg p-4">
                    <span className="text-3xl font-bold">{String(timeLeft.days).padStart(2, '0')}</span>
                  </div>
                  <span className="text-sm text-gray-600 mt-2 block">Dias</span>
                </div>
                <div className="text-center">
                  <div className="bg-red-600 text-white rounded-lg p-4">
                    <span className="text-3xl font-bold">{String(timeLeft.hours).padStart(2, '0')}</span>
                  </div>
                  <span className="text-sm text-gray-600 mt-2 block">Horas</span>
                </div>
                <div className="text-center">
                  <div className="bg-red-600 text-white rounded-lg p-4">
                    <span className="text-3xl font-bold">{String(timeLeft.minutes).padStart(2, '0')}</span>
                  </div>
                  <span className="text-sm text-gray-600 mt-2 block">Minutos</span>
                </div>
                <div className="text-center">
                  <div className="bg-red-600 text-white rounded-lg p-4">
                    <span className="text-3xl font-bold">{String(timeLeft.seconds).padStart(2, '0')}</span>
                  </div>
                  <span className="text-sm text-gray-600 mt-2 block">Segundos</span>
                </div>
              </div>
            </div>

            {/* Book Cover */}
            <div className="rounded-lg shadow-2xl bg-white p-4">
              <img 
                src="https://customer-assets.emergentagent.com/job_jesus-livro/artifacts/76tchu9v_ua68103.jpg" 
                alt="Capa do livro A Vida de Jesus - O Evangelho da Prosperidade Eterna por Marcio Bringhenti"
                className="w-full h-auto object-contain rounded-lg shadow-2xl max-h-96"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;